class storageManager {
    async fetch(key, action) {
        const storedData = localStorage.getItem(key);
        if (storedData) {
            return JSON.parse(storedData);
        }
        
        const sourceData = await action();
        localStorage.setItem(key, JSON.stringify(sourceData));
        return sourceData;
    };
}
export default new storageManager();